var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPokemonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269.469,
    height: 98.88,
    viewBox: "0 0 71.297 26.162",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 37h12v16H18zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.96 39.848l7.673 12.949 2.37-2.402-7.706-13.032zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 49h6v4h-6zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.004 50.395l-2.371 2.402 2.887-1.234 2.402-2.551zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 28h4v4h-4zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.906 29.668l-.293 1.7 2.922-1.567.246-1.774zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 16h16v16H99zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.52 17.992L99.71 31.52l2.958-1.54 11.668-13.515zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 34h5v8h-5zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.707 36.508l-1.277 5.168 2.886-1.516 1.23-5.254zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 73h14v6h-14zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.406 75.234l9.781 3.118 2.903-1.47-9.805-3.167zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 39h6v3h-6zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.691 41.18l2.387.55 2.879-1.52-2.36-.534zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 33h6v5h-6zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.52 35.207l-2.48 1.875 2.937-1.562 2.062-1.657zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 69h4v7h-4zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.316 71.398l.09 3.836 2.88-1.52-.099-3.85zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 30h4v12h-4zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.586 32.52l.105 8.66 2.907-1.504-.172-8.778zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 68h14v4h-14zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.895 70.047l9.421 1.351 2.871-1.535-9.414-1.332zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 67h18v5h-18zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.688 68.672l14.218 2.516 2.836-1.5-14.172-2.563zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134 60h5v9h-5zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.922 62.36l.766 6.312 2.882-1.547-.738-6.324zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129 58h8v10h-8zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.738 60.219l3.61 7.027 3.297-1.586-4.024-7.043zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 61h16v4h-16zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.512 62.64l12.515 2.008 2.852-1.535-12.484-1.968zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 29h9v34h-9zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.656 31.371l-5.144 31.27 2.883-1.496 5.125-31.403zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 29h6v5h-6zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.71 31.52l2.067 2.464 2.899-1.488-2.008-2.516zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 57h27v14H84zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8 59.445l23.184 11.485 2.84-1.493-23.168-11.55zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 26h7v9h-7zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.969 28.184l-3.508 6.66 2.906-1.586 3.48-6.715zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 67h15v5H73zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.594 69.504l-2.926 1.539 11.062-1.629 2.961-1.484zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 39h7v33h-7zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.96 41.188l2.708 29.855 2.926-1.54-2.778-29.855zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 31h5v11h-5zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.844 33.457l.406 8.422 2.902-1.543-.437-8.504zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 73h16v7H41zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.762 77.64l-2.895 1.93 11.742-3.777 2.91-1.848zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 49h16v31H29zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.52 51.563L41.867 79.57l2.895-1.93-12.84-28.628zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 55h22v16H52zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.129 57.758s.633 3.293 1.45 5.601c.816 2.305 2.757 4.172 2.757 4.172a10.75 10.75 0 004.48 2.59c3.278.95 6.98.332 10.153-1.691.828-.528 1.965-1.371 2.656-2.04-3.125 1.903-7.098 2.7-10.29 1.778-3.03-.883-5.468-2.984-6.855-5.926-.707-1.504-1.347-4.867-1.386-6.531-.66.762-2 1.574-2.965 2.047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 39h6v3h-6zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.152 40.336l-2.902 1.543 2.71-.691 2.856-1.54zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 63h9v4h-9zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.105 64.379c-1.714.512-3.503.574-5.164.398l.164 1.38c1.012-.122 2.079-.25 2.98-.567 1.063-.371 3.36-1.383 4.235-2.153-.324.126-1.875.844-2.215.942"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 55h11v5h-11zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.418 55.71c-1.86 1.02-6.832 2.52-8.598 2.548l.047 1.578c2.371-.348 4.41-1.227 6.418-2.43 1.254-.754 2.64-1.883 3.07-2.187-.308.195-.62.316-.937.492"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16.441h170V78H21zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16.441h170V78H21zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16h170v62H21zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.754 30.035c.074.094 1.984 2.43 1.984 2.43.016.012.02.027.02.047 0 .008 0 .011-.004.015 0 .024-.024.043-.043.051-1.809.738-3.403 1.754-4.739 3.016a.082.082 0 01-.101 0l-9.988-8.86c-.086.16-3.485 6.66-3.485 6.66a.076.076 0 01-.082.036c-.035-.008-.054-.035-.054-.07l.132-6.38c-.195.063-15.476 4.942-15.582 4.977.004.11.383 8.133.391 8.309l2.594-.676a.063.063 0 01.062.012.087.087 0 01.031.05l.395 4.29a.07.07 0 01-.031.066.066.066 0 01-.07.008c-3.04-1.364-6.715-1.325-10.083.101-.98.422-1.925.961-2.808 1.598a.077.077 0 01-.086.004c-.024-.02-.04-.047-.031-.082.605-2.657.418-5.227-.54-7.426a13.403 13.403 0 00-5.746-6.336c-1.742-1.16-3.847-1.906-6.085-2.156-5.422-.95-11.946.027-18.364 2.758-2.36 1-4.562 2.148-6.55 3.418 0 0-2.34 1.488-2.454 1.558.18.309 6.188 10.461 6.188 10.461s1.36 2.285 1.422 2.383l2.847-1.39a.129.129 0 01.055 0c.02.007.035.019.043.038l12.805 28.59c.316-.098 11.484-3.668 11.61-3.707-.036-.133-4.083-15.683-4.083-15.683 0-.008-.004-.012-.004-.016a.07.07 0 01.035-.063c.95-.699 1.856-1.464 2.696-2.265.023-.024.054-.024.086-.016.027.016.043.05.039.078a11.67 11.67 0 00.332 4.574c.875 3.114 2.91 5.57 5.738 6.934 3.055 1.469 6.785 1.473 10.238.008a14.897 14.897 0 004.574-3.082c.02-.024.051-.027.079-.02a.086.086 0 01.046.063l.47 5.062c.155-.02 10.831-1.59 10.956-1.61l-.011-9.89c0-.023.011-.05.03-.062a.066.066 0 01.071-.004s22.875 11.312 23.086 11.414V58.27c0-.04.027-.075.066-.075.954-.078 1.907-.23 2.829-.453 2.562-.613 4.742-1.472 6.652-2.617a.077.077 0 01.082.004.08.08 0 01.031.058c0 .004 0 .008-.004.012 0 0-.93 5.742-.96 5.887.148.02 12.21 1.922 12.355 1.945.027-.136.683-4.43.683-4.43 0-.03.027-.058.059-.062.031-.008.062.012.078.035l3.2 5.914c.116-.23 1.925-3.722 1.925-3.722a.076.076 0 01.082-.036c.031 0 .055.028.058.059l.723 6.258c.102.023 13.82 2.445 14.02 2.476l-.739-4.668v-.011c0-.02.008-.035.024-.055.02-.012.039-.023.062-.02 1.946.22 3.993-.046 5.926-.777l1.367-.605c.024-.012.059-.012.078.004a.083.083 0 01.028.058c0 .004-.543 4.88-.555 5.016.133.02 9.363 1.312 9.363 1.312a.073.073 0 01.063.075s.07 3.71.074 3.812c.102.031 9.574 3.012 9.71 3.059.044-.137 12.72-38.313 12.767-38.465-.153-.035-13.051-3.164-13.192-3.2-.031.141-1.246 5.153-1.246 5.153-.012.031-.043.055-.07.055-.04 0-.067-.024-.074-.063 0 0-1.145-5.648-1.165-5.738-.09-.02-15.355-3.375-15.535-3.418.004.18.114 8.445.114 8.558.109.028 2.3.512 2.3.512.04.012.063.04.063.074l-.18 1.586a.089.089 0 01-.039.059.108.108 0 01-.07 0s-.028-.02-.067-.04c-2.902-1.542-6.511-1.69-9.91-.413a14.312 14.312 0 00-3.16 1.703c-.02.02-.047.02-.07.008a.074.074 0 01-.047-.055s-2.324-14.734-2.348-14.863h-10.293c-.023.117-.281 1.652-.281 1.652-.004.035-.04.063-.074.063h-10.91c-.012.12-1.243 7.617-1.243 7.617-.004.027-.027.047-.054.058-.028.008-.055-.004-.074-.027l-.91-1.121c-2.618-3.219-6.43-5.043-10.723-5.133-.031-.004-.063-.023-.07-.058-.005-.004-.005-.012-.005-.016 0-.027.012-.05.043-.063l9.239-4.968c-.09-.13-6.293-9.387-6.395-9.543-.129.144-11.554 13.308-11.633 13.398m4.692.356l-.68-1.028a.067.067 0 01.008-.09l7.063-8.5a.07.07 0 01.058-.027c.02 0 .043.012.055.031l3.434 4.664c.011.016.019.043.011.063-.004.02-.02.043-.039.047l-9.816 4.863c-.012.008-.02.012-.031.012a.07.07 0 01-.063-.035m31 .59a.079.079 0 01.074-.063h5.305c.039 0 .07.027.074.062l2.207 14.32c.004.024-.004.044-.015.063-2.918 3.32-4.122 7.563-3.215 11.352.722 3.015 2.578 5.457 5.242 6.87l.824.392c.023.007.04.03.047.054l.285 1.856a.063.063 0 01-.023.058.075.075 0 01-.059.028l-7.836-1.2c-.031-.007-.058-.03-.062-.066 0 0-1.957-12.996-2.04-13.527-.187.488-2.847 7.359-2.847 7.359-.008.027-.035.043-.063.043-.03.004-.058-.012-.066-.04 0 0-4.219-9.097-4.351-9.374l-1.723 10.863a.064.064 0 01-.031.047.058.058 0 01-.055.016l-7.348-1.282c-.043-.003-.062-.039-.062-.074v-.011s1.031-6.149 1.05-6.196l.82-.797s2.22-2.293 2.329-2.402a925.18 925.18 0 01-2.254-2.023c-.015-.012-.023-.032-.023-.055v-.008l2.457-14.652c.004-.035.035-.059.07-.059h7.43c.03 0 .066.024.07.059 0 0 1.64 8.992 1.777 9.734l2.012-11.348m-47.621.168a.093.093 0 01.059-.035c.015 0 .039.008.054.024l6.883 6.554a.076.076 0 01.024.051c0 .02-.004.04-.024.05L88.277 47.86c.992.395 8.942 3.536 8.977 3.57 1.011 1.907 2.554 3.536 4.46 4.708 1.852 1.14 3.958 1.828 6.247 2.043.039.004.07.035.07.074v6.496c0 .027-.016.047-.035.063-.024.011-.051.015-.074 0L85.019 53.358l.04 11.938c0 .039-.028.066-.063.074l-5.957.817a.098.098 0 01-.055-.016c-.011-.016-.023-.035-.023-.055 0 0-.41-4.863-.41-5.02v-.003c1.3-2.219 1.972-4.664 1.972-7.028 0-1.086-.14-2.152-.43-3.171a10.979 10.979 0 00-2.823-4.81l-.844-10.058c-.16.043-2.594.68-2.594.68-.02.004-.047 0-.062-.016-.02-.011-.028-.03-.032-.054l-.113-2.563c-.004-.031.02-.062.05-.07l9.563-2.848a.08.08 0 01.067.008c.015.016.027.04.027.059l.57 9.652c.239-.332 6.922-9.727 6.922-9.727M30.148 46.422l-4.71-7.957c-.016-.035-.008-.082.027-.102 1.851-1.18 3.914-2.254 6.125-3.191 5.902-2.512 11.836-3.422 16.707-2.567 1.926.22 3.594.797 4.965 1.708 2.187 1.226 3.761 2.93 4.687 5.062a8.33 8.33 0 01.672 3.344c0 4.82-3.68 10.398-9.668 14.11l3.902 14.98v.02c0 .03-.02.062-.046.07l-6.34 2.027c-.04.011-.078-.004-.094-.035 0 0-12.918-28.856-12.984-28.996-.13.066-2 .996-2 .996l-1.149.562a.074.074 0 01-.031.008.074.074 0 01-.063-.04m69.25 3.032a9 9 0 01-.488-1.48c-.75-3.184-.222-6.172 1.531-8.653.47-.66 1.028-1.289 1.668-1.851 1.555-1.387 3.551-2.399 5.77-2.938 4.851-1.168 9.43.211 12.246 3.684.012.012.016.031.016.047 0 .02-.004.035-.016.047 0 0-9.273 9.875-9.473 10.093.746.082 1.817-.14 2.27-.246 2.148-.52 3.41-1.601 4.644-3.062a.081.081 0 01.051-.028c.02 0 .04.008.055.02l4.992 4.492c.016.016.02.035.02.055 0 .02 0 .039-.012.054a20.363 20.363 0 01-1.582 1.461c-2.227 1.84-4.715 3.024-8.082 3.832-.707.168-1.426.29-2.145.364-.476.047-.945.066-1.41.066-4.601 0-8.46-2.25-10.055-5.957m62.274 16.688c-.04-.004-.063-.032-.063-.07v-.009s.422-4.457.446-4.507c3.25-2.743 5.093-6.625 5.093-10.422 0-.887-.097-1.766-.304-2.625-.489-2.035-1.54-3.84-3.047-5.215a.075.075 0 01-.027-.055s.488-5.074.496-5.199c-.114-.027-2.18-.578-2.18-.578a.08.08 0 01-.055-.074l.157-2.809c0-.023.008-.043.027-.055.015-.015.035-.015.058-.015l10.223 2.054c.031.008.05.032.059.063 0 0 3.242 15.367 3.37 15.98.145-.609 3.446-14.296 3.446-14.296a.068.068 0 01.082-.055l7.785 1.719c.02.007.035.023.047.039.012.02.012.039.008.062L176.34 73.246c-.016.035-.055.063-.094.047l-5.437-1.625a.07.07 0 01-.055-.07s-.422-17.938-.453-19.309l-2.61 14.738a.079.079 0 01-.074.063h-.011zM122.008 44.93l-2.043-1.84c-.016-.012-.024-.035-.027-.055 0-.02.004-.039.019-.055l2.844-3.023a.079.079 0 01.086-.016c.027.012.043.043.039.079l-.797 4.867a.074.074 0 01-.047.054c-.012.004-.02.004-.027.004-.016 0-.035-.004-.047-.015m29.555 17.308a8.069 8.069 0 01-3.188-1.37c-1.547-1.106-2.605-2.723-3.07-4.669-.547-2.3-.11-4.855 1.238-7.187a12.375 12.375 0 012.445-3.016 12.14 12.14 0 013.75-2.312c3.114-1.172 6.395-.86 8.762.836a7.482 7.482 0 012.074 2.23c.422.7.739 1.469.938 2.281.656 2.766-.051 5.84-1.95 8.446a12.47 12.47 0 01-2.816 2.789 11.671 11.671 0 01-2.68 1.433 10.628 10.628 0 01-3.742.707 9.1 9.1 0 01-1.761-.168m-55.586-14.09l-3.2-1.242c-.023-.004-.039-.027-.047-.05-.003-.028.008-.051.024-.07l2.98-2.895a.079.079 0 01.082-.012.073.073 0 01.043.074 14.209 14.209 0 00.22 4.113.09.09 0 01-.028.075.082.082 0 01-.043.015c-.012 0-.02-.004-.031-.008M62.305 64.891c-2.153-1.032-3.711-2.922-4.387-5.317-1.43-5.074 1.828-11.105 7.266-13.441 3.273-1.39 6.761-1.176 9.332.57 1.586 1.07 2.703 2.645 3.238 4.531l.152.645c.153.73.215 1.488.192 2.25-.075 2.2-.883 4.476-2.285 6.418-1.376 1.91-3.215 3.394-5.32 4.293-1.442.61-2.903.918-4.31.918-1.367 0-2.68-.29-3.878-.867"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 41h9v13h-9zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.273 42.29l1.032 3.519 1.617 5.207.738 2.37c2.996-1.925 6.004-4.234 5.207-8.5-.398-2.113-2.422-3.577-4.945-3.577-1.152 0-2.399.3-3.649.98m2.82 1.41c.852-.152 1.665-.082 2.333.239.375.175 1.023.59 1.172 1.374.332 1.77-.274 3.036-1.692 4.305-.437-1.414-1.39-4.469-1.398-4.496l-.414-1.422"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 38h10v11h-10zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.527 40.348a5.468 5.468 0 00.344 7.73c.188.172.383.32.582.457l7.195-8.144c-.128-.133-.253-.266-.386-.391a5.46 5.46 0 00-3.696-1.438c-1.48 0-2.96.602-4.039 1.786m1.43 1.304a3.536 3.536 0 013.883-.91l-4.375 4.992a3.534 3.534 0 01.492-4.082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 45h11v10h-11zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.41 49.496c-.105 2.684 2.05 4.887 4.86 5.004 2.859.117 5.187-1.906 5.296-4.59.04-.926-.238-1.812-.734-2.57.063.234.098.48.086.734-.066 1.512-1.496 2.692-3.203 2.621-1.711-.066-3.043-1.36-2.98-2.875.062-1.43 1.327-2.55 2.894-2.625a5.22 5.22 0 00-.93-.12c-.082-.005-.16-.005-.234-.005-2.75 0-4.957 1.98-5.055 4.426"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 47h11v11H63zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.793 52.227c0 2.68 2.246 4.796 5.059 4.796 2.855 0 5.105-2.117 5.105-4.796 0-.934-.309-1.809-.836-2.543.07.23.11.476.11.726 0 1.52-1.383 2.758-3.09 2.758-1.711 0-3.094-1.238-3.094-2.758 0-1.426 1.223-2.597 2.785-2.738a5.645 5.645 0 00-.934-.082c-2.859 0-5.105 2.113-5.105 4.637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 0.013,
    y1: 0,
    x2: 0.845,
    y2: 0,
    gradientTransform: "rotate(75.054 -12.853 32.274) scale(21.02351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1e3064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1c5390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#1b5592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1b5692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#1a5795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#195895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#135f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1060a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#0d62a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0964a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 0.506,
    y1: 0,
    x2: 0.585,
    y2: 0,
    gradientTransform: "scale(-49.03047) rotate(88.877 .504 -1.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1d508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c5390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 0.437,
    y2: 0,
    gradientTransform: "rotate(105.779 56.895 64.86) scale(9.31319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f4982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 0.026,
    y1: 0,
    x2: 1.406,
    y2: 0,
    gradientTransform: "scale(-14.12546) rotate(-67.62 -4.698 5.342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1e3064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#204780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#1d508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#1c528e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#1c5390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#1b5692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#1a5795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#195895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#185a98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#165c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#1061a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#0766a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#0666aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#0567aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#0367ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#0268ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0168ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#0168ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#0069ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#0069ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#0069ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#006aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#006ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#006bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#006bb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#006bb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#006cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#006cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#006cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#006db4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#006eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#006eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#006fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#0070b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#0071b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#0071b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0071b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 0.21,
    y1: 0,
    x2: 0.832,
    y2: 0,
    gradientTransform: "scale(-12.49312) rotate(-70.168 -8.947 8.839)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#204780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#1f4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#1d508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#1c528e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#1c5390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#1b5592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#1a5795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#195895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#165c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#135f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1060a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#0d62a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b63a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: -0.068,
    y1: 0,
    x2: 0.032,
    y2: 0,
    gradientTransform: "rotate(-91.123 122.71 -46.625) scale(49.04777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2e61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 0.13,
    y1: 0,
    x2: 0.392,
    y2: 0,
    gradientTransform: "rotate(-43.052 133.863 -174.985) scale(20.01335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20467e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 0.784,
    y1: 0,
    x2: 0.852,
    y2: 0,
    gradientTransform: "rotate(-91.123 87.227 -11.393) scale(49.07466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1060a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1061a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0d62a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0865a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: -0.001,
    y1: 0,
    x2: 0.109,
    y2: 0,
    gradientTransform: "rotate(-91.123 120.296 -44.208) scale(49.07924)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1e3064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: -0.094,
    y1: 0,
    x2: 0.901,
    y2: 0,
    gradientTransform: "rotate(121.81 71.12 60.857) scale(10.37348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#1f4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#1d508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#1b5592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#1a5795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#135f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#1061a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#0766a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#0666aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#0567aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#0567ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#0367ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0268ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#0268ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#0168ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 0.078,
    y1: 0,
    x2: 0.141,
    y2: 0,
    gradientTransform: "rotate(-91.123 118.008 -41.834) scale(49.03859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 0.009,
    y1: 0,
    x2: 0.111,
    y2: 0,
    gradientTransform: "rotate(-92.367 106.688 -33.264) scale(46.60931)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1e3064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3467"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 0.109,
    y1: 0,
    x2: 0.271,
    y2: 0,
    gradientTransform: "rotate(-91.123 104.781 -30.098) scale(49.07496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203e74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 0.161,
    y1: 0,
    x2: 0.318,
    y2: 0,
    gradientTransform: "rotate(-91.123 104.154 -27.264) scale(56.01519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204178"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 0.162,
    y1: 0,
    x2: 0.251,
    y2: 0,
    gradientTransform: "rotate(-92.367 97.091 -23.514) scale(46.60636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203c72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: -0.431,
    y1: 0,
    x2: 0.721,
    y2: 0,
    gradientTransform: "rotate(-140 70.385 1.79) scale(23.68506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#20447c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1f4780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#1f4c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#1d508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#1c5390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#185998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#1060a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#0765a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#0666aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#0268ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#0169ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#0069ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#006aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#006bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#006bb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#006cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#006db4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#006eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#006fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#0071b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 0.049,
    y1: 0,
    x2: 0.27,
    y2: 0,
    gradientTransform: "scale(28.7963) rotate(-34.43 3.648 -4.914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203e74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    gradientUnits: "userSpaceOnUse",
    x1: 0.084,
    y1: 0,
    x2: 0.364,
    y2: 0,
    gradientTransform: "rotate(-88.375 87.534 -12.456) scale(49.07226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20457c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    gradientUnits: "userSpaceOnUse",
    x1: 0.078,
    y1: 0,
    x2: 1.251,
    y2: 0,
    gradientTransform: "rotate(113.703 36.185 41.761) scale(8.67459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#204780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1f4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#1c528e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1c5390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#1b5692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1a5795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#195895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#185a98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#165c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#135f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#1061a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#0d62a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#0766a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#0666aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#0567aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#0367ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#0268ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#0168ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#0168ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#0069ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#0069ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0069ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#006aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#006ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#006bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#006bb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#006bb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#006bb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#006cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#006cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#006db4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#006db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#006eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#006fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#006fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#0070b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#0070b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#0071b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#0071b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    gradientUnits: "userSpaceOnUse",
    x1: 0.061,
    y1: 0,
    x2: 0.128,
    y2: 0,
    gradientTransform: "scale(-47.90023) rotate(89.769 -.067 -1.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    gradientUnits: "userSpaceOnUse",
    x1: -0.064,
    y1: 0,
    x2: 0.798,
    y2: 0,
    gradientTransform: "scale(-13.59211) rotate(-11.372 -22.976 27.062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#204780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#1c528e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#1b5692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1a5795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#195895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#165c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#1061a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f61a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    gradientUnits: "userSpaceOnUse",
    x1: 0.143,
    y1: 0,
    x2: 0.901,
    y2: 0,
    gradientTransform: "rotate(88.341 19.27 50.603) scale(13.3703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#1f4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#1f4c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#1d508c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#1d518d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#1d518e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1c528e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1c528f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#1c538f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1b5591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#1b5592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1b5692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#1b5693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#1a5794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#195895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#195896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#195997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#195998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#185a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#165c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#145e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#135e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#135f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#125fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#1160a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#1061a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#0f61a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#0e62a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#0d62a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#0d63a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#0c63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0b63a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#0a64a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0964a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#0865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#0766a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#0666aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#0567aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#0567aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#0467ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#0367ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#0367ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#0268ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0168ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#0168ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#0168ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    gradientUnits: "userSpaceOnUse",
    x1: -0.07,
    y1: 0,
    x2: 0.064,
    y2: 0,
    gradientTransform: "rotate(-93.313 60.747 15.097) scale(48.47491)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e3063"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    gradientUnits: "userSpaceOnUse",
    x1: -0.426,
    y1: 0,
    x2: 0.537,
    y2: 0,
    gradientTransform: "scale(-35.36207) rotate(68.095 .85 -1.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#1f4c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d508b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    gradientUnits: "userSpaceOnUse",
    x1: -0.056,
    y1: 0,
    x2: 0.54,
    y2: 0,
    gradientTransform: "rotate(-113.427 56.858 14.034) scale(37.9379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#1d2c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#1e2d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1e2e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#1e2f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#1e3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1f3164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#1f3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#1f3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1f3266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#1f3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#1f3467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#1f3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1f3569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#1f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#1f366a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1f376b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#20386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#20386d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#203c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#203d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#204179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#20437a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#20447b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#20457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#20457d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#20467d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#20467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#20477f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#204780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#1f4880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#1f4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#1f4982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#1f4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#1f4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#1f4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#1f4b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#1f4c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#1f4c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#1e4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#1e4d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#1e4e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#1e4f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#1e4f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#1d508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d508c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    gradientUnits: "userSpaceOnUse",
    x1: 0.694,
    y1: 0,
    x2: 0.742,
    y2: 0,
    gradientTransform: "scale(-49.06946) rotate(88.877 .059 -1.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#175b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#175b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#165c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#165c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#155d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155d9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    gradientUnits: "userSpaceOnUse",
    x1: 0.183,
    y1: 0,
    x2: 0.247,
    y2: 0,
    gradientTransform: "rotate(-86.835 117.323 -44.232) scale(49.12996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20396d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20396e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#203a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#203b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#203b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#203c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203c72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    gradientUnits: "userSpaceOnUse",
    x1: 0.271,
    y1: 0,
    x2: 0.355,
    y2: 0,
    gradientTransform: "matrix(-1.9834 -59.49661 55.03901 -2.14394 116.233 76.167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#203e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#203e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#203f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#203f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#204077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#204178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#204279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#20427a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#20437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20447b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    gradientUnits: "userSpaceOnUse",
    x1: 0.003,
    y1: 0,
    x2: 0.997,
    y2: 0,
    gradientTransform: "scale(-63.05241) rotate(89.396 -.215 -1.477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c5aa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#3c5aa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#3b5ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#3b5ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#3b5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#3b5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#3b5da8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3a5da9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#3a5ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#3a5eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#395faa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#395faa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#3861ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#3861ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3862ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#3764ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#3664ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#3665ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#3665af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#3666af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#3566af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#3566b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#3469b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#3369b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#336ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#336ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#336bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#326bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#326bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#326cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#316cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#316db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#316eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#306eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#306eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#306fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#2f6fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#2f70b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#2f70b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#2e70b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#2e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#2d72b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#2d72b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#2c73b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#2c73ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#2b74ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b74bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    gradientUnits: "userSpaceOnUse",
    x1: 0.308,
    y1: 0,
    x2: 0.538,
    y2: 0,
    gradientTransform: "rotate(-90.604 58.917 10.635) scale(52.75348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3862ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3764ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#3664ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#3665ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3665af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#3666af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3566af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#3566b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3468b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    gradientUnits: "userSpaceOnUse",
    x1: 0.35,
    y1: 0,
    x2: 0.55,
    y2: 0,
    gradientTransform: "scale(-50.514) rotate(89.396 -.417 -1.748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3764ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#3664ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3665ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#3665af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#3666af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3566af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3566b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3468b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    gradientUnits: "userSpaceOnUse",
    x1: 0.076,
    y1: 0,
    x2: 0.933,
    y2: 0,
    gradientTransform: "scale(-11.26966) rotate(89.396 -4.412 -9.438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#3b5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#3b5da8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#3a5da9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#3a5ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#3a5eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#395faa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#395faa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#3861ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#3861ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3862ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#3862ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#3764ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#3664ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#3665ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#3665af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#3666af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#3566af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#3566b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#3469b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#3369b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#336ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#336ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#336bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#326bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#326bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#326cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#316cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#316db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#316eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#306eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#306fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#2f6fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2f70b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#2e70b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#2e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#2d72b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c73b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    gradientUnits: "userSpaceOnUse",
    x1: 0.077,
    y1: 0,
    x2: 0.942,
    y2: 0,
    gradientTransform: "scale(-11.03767) rotate(89.396 -.47 -5.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#3b5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#3b5da8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#3a5da9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#3a5ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#3a5eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#395faa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#395faa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#3960ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#3861ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#3861ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3862ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#3862ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#3763ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#3764ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#3664ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#3665ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#3665af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#3666af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#3566af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#3566b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#3567b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#3468b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#3469b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#3369b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#336ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#336ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#336bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#326bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#326bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#326cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#316cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#316db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#316db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#316eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#306eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#306eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#306fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#2f6fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2f70b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#2e70b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#2e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#2e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#2d72b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#2c73b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c73ba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 11.554
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.336 34.863l-13.223 3.528 4.516 16.906 13.219-3.527zm0 0",
    fill: "url(#c)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.637 52.902l5.36-.105-.079-3.89-5.36.105zm0 0",
    fill: "url(#f)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.652 28.277l-3.804-1.078-1.106 3.922 3.805 1.074zm0 0",
    fill: "url(#i)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.637 18.648l-17.805-7.332-7.422 18.02 17.805 7.332zm0 0",
    fill: "url(#l)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.707 35.684l-5.805-2.094-2.636 7.308 5.808 2.094zm0 0",
    fill: "url(#o)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.41 78.602l12.77-.25-.094-4.887-12.77.25zm0 0",
    fill: "url(#r)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.668 40.633l3.477 3.722 3.835-3.582-3.476-3.722zm0 0",
    fill: "url(#u)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.043 37.18l5.062-.098-.066-3.316-5.062.097zm0 0",
    fill: "url(#x)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.32 75.293l3.07-.059-.109-5.43-3.07.063zm0 0",
    fill: "url(#A)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.203 33.754l-6.781-4.203-5.442 8.773 6.778 4.203zm0 0",
    fill: "url(#D)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M56.748 22.215l1.194-.628 1.31-11.733-1.184.625zm0 0",
    fill: "#2e216e"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.902 71.64l12.344-.242-.062-3.109-12.344.242zm0 0",
    fill: "url(#G)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.715 71.89l17.195-.71-.195-4.758-17.195.71zm0 0",
    fill: "url(#J)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.922 68.742l3.8-.074-.152-7.941-3.804.074zm0 0",
    fill: "url(#M)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.742 67.383l7.07-.14-.171-8.763-7.07.141zm0 0",
    fill: "url(#P)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.54 65.281l15.483-.64-.171-4.133-15.485.64zm0 0",
    fill: "url(#S)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.21 66.586l19.509-23.25-20.899-17.54-19.507 23.25zm0 0",
    fill: "url(#V)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.844 31.258L101.3 36.3l5.242-3.598-3.453-5.039zm0 0",
    fill: "url(#Y)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.43 70.918l26.375.746.39-13.766-26.375-.75zm0 0",
    fill: "url(#ab)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.902 27.883l-8.41-3.692-4.09 9.313 8.414 3.691zm0 0",
    fill: "url(#ae)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.668 71.102l14.035-.059-.012-3.168-14.035.055zm0 0",
    fill: "url(#ah)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.66 69.824L76.375 38.56l-11.48 2.312 6.285 31.262zm0 0",
    fill: "url(#ak)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.148 31.734l-3.597.106.293 10.133 3.597-.106zm0 0",
    fill: "url(#an)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.918 80.418l14.926-.867-.375-6.45-14.926.864zm0 0",
    fill: "url(#aq)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.64 84.848l23.7-9.532-12.7-31.582-23.699 9.528zm0 0",
    fill: "url(#at)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.527 78.91l23.7-10.27-9-20.773-23.704 10.27zm0 0",
    fill: "url(#aw)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.254 41.984l5.605-.109-.043-2.336-5.609.11zm0 0",
    fill: "url(#az)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aA)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.793 66.148l7.508.415.172-3.118-7.508-.418zm0 0",
    fill: "url(#aC)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aD)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.836 60.207l9.672-.379-.164-4.98-9.676.379zm0 0",
    fill: "url(#aF)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aG)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.742 45.547l-.347.394-.25-.457a3.893 3.893 0 01.542-4.504 3.88 3.88 0 014.282-1.007l.488.191-.344.39zm-57.578 3.93l-.445.398-.18-.57-1.812-5.922-.122-.41.418-.078c.95-.172 1.836-.083 2.57.265.438.211 1.204.703 1.384 1.656.34 1.825-.2 3.22-1.813 4.66m72.895-4.601l-2.047-1.84 2.187-2.332.656-.695zM92.805 46.84l2.98-2.895a14.18 14.18 0 00.219 4.137zm84.78-11.871l-1.265 5.222-1.168-5.785-15.675-3.449.113 8.711 2.36.527-.177 1.575a.49.49 0 00-.066-.043c-2.922-1.551-6.547-1.704-9.973-.415a14.104 14.104 0 00-3.171 1.715l-2.36-14.925h-10.422l-.293 1.71H124.52l-1.258 7.684-.91-1.125c-2.657-3.273-6.508-5.07-10.774-5.16l9.309-5.004-6.496-9.691-11.735 13.515 2.028 2.48c-1.84.747-3.442 1.782-4.762 3.028l-10.063-8.926-3.527 6.746.137-6.48-15.735 5.023.403 8.457 2.676-.699.402 4.29c-3.059-1.376-6.73-1.348-10.145.097-1.007.433-1.953.98-2.824 1.61.594-2.61.453-5.184-.539-7.481a13.51 13.51 0 00-5.773-6.364c-1.778-1.18-3.895-1.917-6.114-2.167-5.437-.954-11.976.027-18.406 2.761a45.136 45.136 0 00-6.566 3.422l-2.512 1.602 1.516 2.566 4.71 7.957s1.446 2.445 1.454 2.442l2.554-1.247.356-.171 11.707 26.136 1.125 2.516 2.625-.84 6.34-2.023 2.773-.891-.734-2.82-3.364-12.93a26.524 26.524 0 002.704-2.27 11.86 11.86 0 00.332 4.602c.882 3.133 2.933 5.61 5.78 6.977 3.071 1.48 6.829 1.484 10.298.011a14.91 14.91 0 004.597-3.101l.48 5.144 11.09-1.629-.011-9.957 23.187 11.47V58.27c.938-.079 1.891-.227 2.84-.458 2.559-.613 4.735-1.464 6.676-2.624l-.976 5.957 12.503 1.972.696-4.508 3.265 6.036 1.989-3.844.73 6.312 14.176 2.5-.75-4.77c1.934.22 3.984-.034 5.96-.78.47-.18.93-.387 1.38-.614l-.574 5.082 9.433 1.32.082 3.868 9.828 3.094 12.813-38.61zm0 0",
    fill: "#ffca02"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.616 13.614c.073.075.005.02.09.077l.577-.357a2.81 2.81 0 01-.265-.223c-.803-.735-.594-2.38-.07-3.281-1.374 1.105-1.301 2.81-.332 3.785",
    fill: "#c79e07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.305 14.36c-.913.755-1.957 1.249-3.336 1.58a6.253 6.253 0 01-.886.15c-2.187.213-4.021-.794-4.72-2.422a3.729 3.729 0 01-.201-.609c-.322-1.373-.049-2.598.63-3.56.066-.092.136-.183.21-.27-.032.028-.066.053-.099.083-.259.23-.488.484-.684.762-.679.962-.954 2.185-.63 3.56.048.21.115.414.2.607.698 1.63 2.533 2.637 4.721 2.423a6.27 6.27 0 00.884-.149c1.38-.331 2.424-.825 3.337-1.583.223-.183.44-.383.65-.602l-.02-.021c-.019.018-.036.036-.056.05M29.334 6.78l-.1-.093-2.358 3.312.013.215zm11.43-3.031l-1.423-1.933-.526.636 1.22 1.66zM16.13 9.516c-.387-.892-1.053-1.592-1.928-2.082-.633-.423-1.362-.627-2.047-.706-1.942-.34-4.364-.02-6.909 1.062-.905.385-1.755.825-2.535 1.32l.102.172c.588-.335 1.21-.64 1.859-.917C7.215 7.283 9.637 6.96 11.58 7.303c.685.077 1.413.281 2.046.704.876.49 1.543 1.191 1.93 2.082.688 1.588.079 3.69-1.543 5.455 2.035-1.865 2.88-4.266 2.116-6.028m8.27 5.177a2.843 2.843 0 00-.063-.264 3.305 3.305 0 00-1.33-1.864c-1.015-.688-2.429-.828-3.839-.233a5.297 5.297 0 00-1.899 1.404 5.18 5.18 0 011.326-.829c1.409-.599 2.823-.456 3.838.233a3.306 3.306 0 011.393 2.126c.063.306.089.615.077.926-.029.926-.37 1.853-.942 2.645a4.53 4.53 0 01-.283.354c.324-.276.613-.589.86-.93.57-.79.91-1.718.94-2.642a3.867 3.867 0 00-.078-.926",
    fill: "#c79e07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.51 13.517c-.007.008.572-.576.564-.576-.722-.026-1.03.656-1.054.71.148-.07.313-.12.49-.134m1.36.834c.03.096.05.196.05.301 0 .152-.037.295-.096.427.115-.056.95-.463.624-1.324.02.026-.597.594-.577.596m-3.292.48c0-.357.604-1.213.794-1.501-.955.608-1.368 1.43-1.368 2.073 0 1.114.973 2.003 2.138 2.003.552 0 1.56-.292 2.216-1.362-.343.229-1.223.774-1.683.774-1.166 0-2.097-.877-2.097-1.988m8.206 5.496l.577-.08-.003-4.99-.588.59zm-.461-9.33l.562-.788-.24-4.082-3.961 1.181.018.399 3.37-1.004zm3.484-4.883l-.475.667 2.788 2.616.54-.568zm4.47 10.365a5.166 5.166 0 01-1.86-1.963l-3.739-1.48-.54.57 3.705 1.484a5.13 5.13 0 001.86 1.962 6.002 6.002 0 002.603.852v1.829l.573.288v-2.692a6.049 6.049 0 01-2.603-.85m4.096-2.734c.913-.219 1.44-.695 1.894-1.22a3.18 3.18 0 01-1.32.647c-.317.078-.742.147-1.013.1l-.563.6c.257.02.686-.05 1.002-.127m-1.515-6.216c-.926.221-1.74.64-2.38 1.209-.172.152-.33.319-.476.492a5.546 5.546 0 012.281-1.128c2.085-.502 3.92.134 5.057 1.54l.56-.598c-1.12-1.381-2.956-2.019-5.042-1.515m5.502 6.781c.204-.17.403-.351.596-.554l-.48-.432-1.589-1.43a4.928 4.928 0 01-.567.583l1.579 1.42zm11.496 5.418a4.154 4.154 0 01-.345-.162c-1.11-.59-1.886-1.609-2.187-2.868-.389-1.63.175-3.408 1.337-4.732l-.915-5.935h-2.198l-.102.575h1.727l.915 5.935c-1.164 1.324-1.727 3.101-1.337 4.73.298 1.26 1.075 2.28 2.185 2.868.112.06.227.114.345.162l.014.091.678.105zm-5.746-8.253l.573-.58-.765-4.194H44.84l-.099.575h2.6zm.342 5.547l.193.412 1.215-3.153-.57.571zm-2.23-2.956l-.62 3.912.467.083.73-4.573zm12.26-1.83c.337.245.627.552.85.917.168.28.301.592.382.935.285 1.184-.057 2.453-.801 3.476a5.381 5.381 0 01-.241.303c.306-.261.58-.557.814-.878.746-1.023 1.086-2.29.801-3.474a3.207 3.207 0 00-.382-.937 3.109 3.109 0 00-.85-.916c-.937-.67-2.26-.849-3.603-.34a4.928 4.928 0 00-2.004 1.426c.42-.358.901-.651 1.43-.853 1.344-.507 2.665-.329 3.604.341",
    fill: "#c79e07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.478 12.491c.01.024.568-.578.583-.58-.706.03-1.047.37-1.012.53-.04.058-.076.12-.105.184.152-.074.43-.13.534-.134m1.33.887c.025.099.036.2.032.304a.96.96 0 01-.09.378c.107-.052.959-.314.635-1.255.008.026-.587.578-.578.573m-1.878 2.995c.8.032 1.684-.461 2.317-1.33-.366.242-1.264.749-1.756.73-1.164-.05-2.06-.962-2.016-2.073.014-.325.437-1.026.607-1.292-.612.447-1.154 1.302-1.18 1.906-.044 1.112.863 2.012 2.028 2.059m10.578-7.304l-.16.667 2.81.621-4.316 13.07.35.103 4.54-13.747zM64.474 15.7l.576-.581-1.428-6.75-4.236-.85-.038.68 3.703.742zm-3.327 5.184l.46.072 1.138-6.404-.58.569zM12.402 16.72l-.635.445 1.605 6.013.707-.117zm1.282-2.982c-.4.423-1.284 1.245-1.79 1.572l-.306-.984-.67-2.157-.428-1.46-.416.536.426 1.46.67 2.157.308.984c.69-.445 1.695-1.28 2.206-2.108",
    fill: "#c79e07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.214 9.85c-.545-.211-1.32-.148-1.738.31a3.073 3.073 0 00-.343.498c.403-.32 1.123-.39 1.594-.221zm-25.03 1.95c-.062-.327-.377-.58-.531-.654-.279-.133-.756-.154-1.109-.09l.167.579c.142.018.374.058.497.116.157.076.424.246.485.573.081.434.06.839-.118 1.17.494-.488.735-1.018.609-1.694",
    fill: "#7d7f68"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.219 73.133c-.133-.043-5.215-1.563-5.317-1.59 0-.11-.472-20-.472-20 0-.04-.032-.066-.07-.07-.036-.004-.075.023-.079.058 0 0-2.695 15.258-2.722 15.399-.141-.02-5.664-.903-5.797-.922.011-.133.418-4.387.418-4.387 3.258-2.734 5.117-6.652 5.117-10.488 0-.895-.102-1.785-.309-2.656-.496-2.055-1.55-3.875-3.062-5.266.004-.063.492-5.223.492-5.227a.075.075 0 00-.055-.07s-2.07-.55-2.183-.582c.008-.113.14-2.504.148-2.66.164.035 10 2.012 10.086 2.031.027.09 3.434 16.254 3.434 16.254.008.035.039.059.074.059.031 0 .062-.02.074-.055 0 0 3.465-14.406 3.5-14.547.14.031 7.473 1.656 7.633 1.688-.055.156-10.863 32.894-10.91 33.03m-16.555-12.991a11.734 11.734 0 01-2.648 1.422c-1.82.687-3.696.87-5.422.53a7.927 7.927 0 01-3.133-1.34c-1.516-1.089-2.559-2.675-3.016-4.585-.539-2.266-.101-4.781 1.223-7.082a12.182 12.182 0 012.418-2.977c1.11-1 2.355-1.77 3.703-2.285 3.07-1.156 6.297-.851 8.625.817a7.397 7.397 0 012.035 2.187c.418.688.727 1.442.918 2.242a8.7 8.7 0 01.242 2.043c0 2.137-.754 4.34-2.168 6.278a12.205 12.205 0 01-2.777 2.75m-7.672 4.777h.012zm-10.562-.285l-2.07-13.75a.07.07 0 00-.063-.063c-.035 0-.07.016-.078.047 0 0-2.766 7.145-2.887 7.453-.137-.3-4.34-9.36-4.34-9.36-.008-.026-.07-.042-.101-.038-.032.004-.078.031-.086.058 0 0-1.711 10.81-1.739 10.95-.14-.024-7.062-1.227-7.203-1.25.024-.14 1.016-6.075 1.016-6.082.016.011.805-.762.805-.762l2.379-2.453a.07.07 0 00.019-.051v-.004c0-.02-.008-.039-.023-.05 0 0-2.211-1.997-2.278-2.051.016-.079 2.418-14.422 2.438-14.543h7.304c.02.117 1.836 10.078 1.836 10.078.008.035.04.058.075.058a.075.075 0 00.074-.058s2.055-11.574 2.074-11.696h5.184c.015.125 2.18 14.168 2.187 14.227-2.281 2.617-3.52 5.789-3.52 8.879 0 .867.098 1.734.297 2.574.731 3.063 2.618 5.54 5.313 6.969 0 0 .7.328.805.379l.265 1.715c-.195-.028-7.574-1.157-7.683-1.176m-19.422-19.906c-.176-.16-1.79-1.61-1.89-1.7.097-.105 2.132-2.273 2.132-2.273l.492-.524c-.07.422-.695 4.258-.734 4.497m-1.012 6.308c-2.203 1.824-4.68 2.996-8.023 3.8-.696.173-1.41.29-2.118.36-5.152.5-9.593-1.777-11.32-5.804a8.614 8.614 0 01-.484-1.457c-.735-3.137-.215-6.086 1.512-8.524.46-.66 1.011-1.273 1.64-1.832 1.54-1.371 3.516-2.371 5.711-2.906 4.766-1.145 9.27.195 12.055 3.59-.094.093-9.531 10.152-9.531 10.152a.063.063 0 00-.024.05c0 .005 0 .013.004.024.012.02.031.043.059.051.773.137 1.992-.125 2.476-.242 2.16-.524 3.438-1.598 4.672-3.05.106.097 4.645 4.175 4.88 4.386-.49.5-.997.972-1.509 1.402m-25.082-3.07c-.215-.082-2.785-1.078-2.973-1.153.145-.144 2.528-2.453 2.762-2.683a11.92 11.92 0 00-.055 1.125c0 .898.094 1.805.266 2.71m11.969 16.665c-.215-.106-22.906-11.457-22.906-11.457a.074.074 0 00-.07.004.087.087 0 00-.036.066l.04 11.988c-.126.02-5.665.774-5.813.797-.008-.148-.41-4.898-.41-4.898 1.304-2.219 1.984-4.676 1.984-7.059a11.83 11.83 0 00-.438-3.218 10.953 10.953 0 00-2.836-4.829v-.003c0-.204-.832-10.09-.832-10.09 0-.02-.015-.043-.03-.055a.08.08 0 00-.06-.012s-2.425.633-2.597.68c-.004-.168-.098-2.309-.106-2.414.106-.035 9.247-2.754 9.418-2.8.012.179.579 9.76.579 9.76 0 .032.02.056.05.067.035.008.063 0 .082-.027l6.996-9.828c.122.113 6.664 6.344 6.766 6.445-.098.106-9.566 10.09-9.566 10.09a.063.063 0 00-.024.05c0 .005 0 .012.004.016.004.028.02.043.043.055l9.04 3.574c.987 1.899 2.546 3.547 4.476 4.735 1.855 1.14 3.953 1.828 6.246 2.054zM75.69 60.46c-1.359 1.887-3.175 3.355-5.257 4.246-2.801 1.184-5.668 1.203-8.067.055-2.117-1.02-3.64-2.875-4.304-5.227-1.41-5.008 1.808-10.957 7.175-13.27 3.23-1.367 6.668-1.156 9.196.56 1.554 1.054 2.652 2.593 3.18 4.452l.148.63c.148.718.215 1.468.187 2.218-.07 2.168-.87 4.418-2.258 6.336m-26.859-3.723c-.023.012-.035.035-.035.063v.015l3.898 14.965c-.129.043-6.09 1.946-6.21 1.985l-12.989-29a.085.085 0 00-.043-.04c-.02-.007-.039-.003-.058.008l-2.07 1.024-1.083.531c-.07-.113-4.562-7.71-4.637-7.836a42.049 42.049 0 016.043-3.148c5.875-2.496 11.782-3.403 16.625-2.555 1.907.219 3.559.79 4.914 1.691 2.16 1.211 3.715 2.891 4.625 4.989.446 1.03.66 2.14.66 3.293 0 4.78-3.667 10.324-9.64 14.015m65.055-35.797c.11.141 3.222 4.383 3.324 4.516-.156.078-9.563 4.742-9.68 4.797-.062-.09-.562-.848-.613-.926.07-.082 6.852-8.246 6.969-8.387m77.105 17.23a.065.065 0 00-.047-.034l-13.336-3.239c-.027-.007-.043 0-.062.008-.016.008-.031.028-.031.047 0 0-1.051 4.328-1.188 4.899-.12-.582-1.11-5.465-1.11-5.465 0-.028-.027-.051-.05-.055l-15.676-3.45a.092.092 0 00-.066.016c-.016.016-.027.032-.027.059l.117 8.71a.09.09 0 00.058.075l2.297.508a161 161 0 01-.16 1.402c-2.934-1.547-6.578-1.695-10.004-.406a14.262 14.262 0 00-3.094 1.66c-.03-.215-2.34-14.812-2.34-14.812-.003-.04-.03-.067-.07-.067h-10.422a.075.075 0 00-.074.067s-.262 1.535-.285 1.648H124.52c-.036 0-.07.024-.075.059l-1.226 7.52-.813-.993c-2.582-3.191-6.34-5.016-10.574-5.172l9.086-4.883c.023-.011.035-.027.04-.046v-.02a.076.076 0 00-.013-.04l-6.492-9.694a.067.067 0 00-.054-.032c-.028 0-.047.004-.063.024l-11.738 13.523a.063.063 0 00-.02.043c0 .02.008.035.02.051l1.969 2.402c-1.766.73-3.329 1.723-4.649 2.957-.09-.082-10.008-8.882-10.008-8.882a.076.076 0 00-.062-.016c-.024 0-.043.016-.055.035 0 0-3.11 5.953-3.379 6.465l.13-6.164c0-.024-.009-.047-.028-.055a.063.063 0 00-.067-.015l-15.738 5.023c-.027.008-.055.04-.05.07l.402 8.461c0 .02.011.043.03.055.017.016.044.016.063.012 0 0 2.434-.633 2.59-.676.02.16.36 3.863.383 4.086-3.055-1.332-6.719-1.285-10.086.14-.937.403-1.844.922-2.695 1.524.21-.973.32-1.938.32-2.871 0-1.594-.3-3.106-.898-4.485a13.51 13.51 0 00-5.801-6.398c-1.762-1.172-3.887-1.926-6.14-2.18-5.45-.953-12 .028-18.446 2.77a45.195 45.195 0 00-6.57 3.426l-2.516 1.597c-.035.024-.047.067-.024.102L27.5 47.988c1.48 2.504 1.48 2.504 1.547 2.473.004 0 2.754-1.34 2.844-1.387l12.8 28.586c.016.035.051.05.09.04l11.739-3.755c.027-.007.054-.039.054-.07 0-.008 0-.012-.004-.02l-4.09-15.703a27.256 27.256 0 002.54-2.132c-.047.449-.082.894-.082 1.332 0 1.078.144 2.125.425 3.125.887 3.152 2.957 5.648 5.82 7.027 3.09 1.484 6.868 1.488 10.356.008a14.829 14.829 0 004.508-3.012l.469 4.996c0 .02.011.04.027.05.016.013.035.016.055.013l11.093-1.63a.072.072 0 00.067-.07l-.016-9.84c.211.106 23.086 11.419 23.086 11.419a.06.06 0 00.067-.004.074.074 0 00.039-.063V58.332c.937-.082 1.87-.23 2.78-.445 2.52-.61 4.669-1.45 6.56-2.563-.044.281-.95 5.809-.95 5.809v.008c0 .02.004.03.016.046.008.016.027.028.05.032l12.497 1.968c.02.008.043 0 .058-.011a.08.08 0 00.028-.047s.597-3.895.66-4.29c.195.364 3.16 5.845 3.16 5.845.012.023.04.039.066.039.028 0 .051-.016.063-.043 0 0 1.68-3.246 1.879-3.633.05.45.699 6.074.699 6.074.004.035.031.063.062.063l14.18 2.503c.024 0 .047 0 .067-.019.011-.016.023-.035.023-.055 0 0 0-.008-.004-.008l-.738-4.68c1.937.2 3.976-.07 5.898-.792 0 0 .93-.418 1.266-.563l-.559 4.961c0 .035.027.067.063.07 0 0 9.25 1.297 9.375 1.313 0 .121.074 3.805.074 3.805 0 .031.023.062.055.07l9.828 3.094a.076.076 0 00.093-.051l12.813-38.602a.074.074 0 00-.004-.058",
    fill: "#3a59a6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.601 11.447c.146.068.397.228.453.53.023.125.036.245.036.36 0 .476-.222.88-.656 1.294l-.547-1.762-.152-.52c.322-.05.623-.019.866.098m-2.138-.785a.056.056 0 00-.028.066l.426 1.459.978 3.142c.006.018.019.03.035.037a.055.055 0 00.052-.006c1.289-.83 2.519-1.79 2.182-3.581-.105-.562-.487-1.036-1.046-1.302-.757-.359-1.727-.29-2.6.185m25.68.775c0-.343.126-.684.37-.95.37-.408.932-.542 1.455-.377-.119.134-1.55 1.766-1.676 1.91a1.395 1.395 0 01-.149-.583m1.302-2.324a2.313 2.313 0 00-1.613.754 2.312 2.312 0 00-.607 1.674 2.3 2.3 0 00.755 1.612l.247.195c.025.019.057.014.076-.008l2.98-3.376c.02-.022.022-.056 0-.077l-.164-.165a2.305 2.305 0 00-1.674-.609m17.595 3.275c-.38.351-.602.817-.622 1.31-.045 1.146.865 2.083 2.07 2.133 1.22.049 2.21-.81 2.258-1.957a1.864 1.864 0 00-.318-1.1c-.012-.022-.04-.028-.066-.019-.026.008-.04.04-.037.065l.034.287c-.025.595-.595 1.058-1.266 1.03a1.293 1.293 0 01-.902-.4 1.018 1.018 0 01-.279-.73c.023-.56.515-1.003 1.145-1.032.03 0 .057-.024.058-.053 0-.031-.02-.057-.048-.06l-.397-.054a2.288 2.288 0 00-1.63.58M18.52 14.83c0 1.147.947 2.048 2.155 2.048 1.219 0 2.174-.9 2.174-2.048 0-.386-.123-.761-.358-1.088-.014-.023-.042-.026-.068-.016-.024.01-.039.04-.034.066l.044.285c0 .599-.55 1.085-1.224 1.085-.675 0-1.224-.486-1.224-1.085 0-.558.473-1.021 1.1-1.076.03-.004.056-.028.056-.059 0-.03-.021-.055-.05-.056l-.397-.036c-1.2 0-2.174.889-2.174 1.98",
    fill: "#3a59a6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aJ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.453 79.32l170.02-1.793-.66-62.68-170.02 1.794zm0 0",
    fill: "url(#aK)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aM)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.277 53.484l9.516-.097-.129-12.176-9.516.098zm0 0",
    fill: "url(#aN)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aP)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.488 48.645l10.266-.11-.11-10.078-10.265.105zm0 0",
    fill: "url(#aQ)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aR)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aS)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.305 54.723l10.398-.11-.101-9.652-10.399.11zm0 0",
    fill: "url(#aT)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aU)",
    transform: "matrix(.41442 0 0 .41442 -7.858 -6.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aV)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.793 57.133l10.262-.11-.098-9.543-10.262.11zm0 0",
    fill: "url(#aW)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokemonLogo);
export default __webpack_public_path__ + "static/media/pokemon-logo.6a748222880a9d71172803d154c98e86.svg";
export { ForwardRef as ReactComponent };